import http from '../../../../api/http'

// 상시채용관 현황 > 재직자/기업 > 상담 tab count
function retrieveJobFairCorpCount() {
  return http.get('/admin/jobFair/retrieveJobFairCorpCount');
}

// 상시채용관 현황 > 재직자/기업 > 기업정보
function retrieveAllJobFairCorpPaging(paramObj) {
  return http.post('/admin/jobFair/retrieveAllJobFairCorpPaging', paramObj);
}

// 상시채용관 현황 > 재직자/기업 > 채용공고
function retrieveJobNoticeListPaging(paramObj) {
  return http.post('/admin/jobFair/jobNotice/retrieveJobNoticeListPaging', paramObj);
}

// 상시채용관 현황 > 재직자/기업 > 채용공고 > 입사지원
function retrieveResumeListByJobNoticeSeqAdminPaging(paramObj) {
  return http.post('/admin/jobFair/resume/retrieveResumeListByJobNoticeSeqAdminPaging', paramObj);
}

// 상시채용관 현황 > 재직자/기업 > 입사지원
function retrieveAllResumeListAdminPaging(paramObj) {
  return http.post('/admin/jobFair/resume/retrieveAllResumeListAdminPaging', paramObj);
}

// 상시채용관 현황 > 재직자/기업 > 보낸 면접제안
function retrieveAllInterviewProposalEntryListPaging(paramObj) {
  return http.post('/admin/jobFair/interviewProposalEntry/retrieveAllInterviewProposalEntryListPaging', paramObj);
}

// 상시채용관 현황 > 학생/구직자 > 받은 면접제안 
function retrieveReceivedInterviewProposalEntryListPaging(paramObj) {
  return http.post('/admin/jobFair/interviewProposalEntry/retrieveReceivedInterviewProposalEntryListPaging', paramObj);
} 

// 상시채용관 현황 > 학생/취업준비생 > 상담 tab count
function retrieveJobFairStuCount() {
  return http.get('/admin/jobFair/retrieveJobFairStuCount');
}

// 상시채용관 현황 > 학생/취업준비생 > 회원정보
function retrieveAllJobFairStuPaging(paramObj) {
  return http.post('/admin/jobFair/retrieveAllJobFairStuPaging', paramObj);
}

// 기업상세 > [TAB]관심인재 > 관심인재 목록 조회
function retrieveInterestHallEntryListPagingByCorpId(paramObj) {
  return http.post(`/admin/jobFair/interestHallEntry/retrieveInterestHallEntryListPagingByCorpId`, paramObj);
}

// 기업상세 > [TAB]보낸 면접제안 > 보낸 면접제안 목록 조회
function retrieveAllInterviewProposalEntryListPagingByCorpId(paramObj) {
  return http.post(`/admin/jobFair/interviewProposalEntry/retrieveAllInterviewProposalEntryListPagingByCorpId`, paramObj);
}

// 회원상세 > [TAB]이력서 관리 및 입사지원 현황
function retrieveJobFairResumeListAdminPagingByUserId(paramObj) {
  return http.post(`/admin/jobFair/resume/retrieveJobFairResumeListAdminPagingByUserId`, paramObj);
}

// 회원상세 > [TAB]관심기업
function retrieveInterestHallEntryCorpListPagingByUserId(paramObj) {
  return http.post(`/admin/jobFair/interestHallEntry/retrieveInterestHallEntryCorpListPagingByUserId`, paramObj);
}

// 회원상세 > [TAB]관심기업
function retrieveInterestJobNoticeListPagingByUserId(paramObj) {
  return http.post(`/admin/jobFair/interestJobNotice/retrieveInterestJobNoticeListPagingByUserId`, paramObj);
}

// 회원상세 > [TAB]관심기업 > 채용공고
function retrieveJobNoticeListPagingByUserId(paramObj) {
  return http.post(`/admin/jobFair/jobNotice/retrieveJobNoticeListPagingByUserId`, paramObj);
}

// 회원상세 > [TAB]받은 면접제안
function retrieveReceivedInterviewProposalEntryListPagingByUserId(paramObj) {
  return http.post(`/admin/jobFair/interviewProposalEntry/retrieveReceivedInterviewProposalEntryListPagingByUserId`, paramObj);
}

export default {
  retrieveJobFairCorpCount,
  retrieveAllJobFairCorpPaging,
  retrieveJobNoticeListPaging,
  retrieveResumeListByJobNoticeSeqAdminPaging,
  retrieveAllResumeListAdminPaging,
  retrieveAllInterviewProposalEntryListPaging,
  retrieveReceivedInterviewProposalEntryListPaging,
  retrieveJobFairStuCount,
  retrieveAllJobFairStuPaging,
  retrieveInterestHallEntryListPagingByCorpId,
  retrieveAllInterviewProposalEntryListPagingByCorpId,
  retrieveJobFairResumeListAdminPagingByUserId,
  retrieveInterestHallEntryCorpListPagingByUserId,
  retrieveInterestJobNoticeListPagingByUserId,
  retrieveJobNoticeListPagingByUserId,
  retrieveReceivedInterviewProposalEntryListPagingByUserId,
}

